<template>
  <div class="drag-drop-area" ref="dropArea" :class="statusClass">
    <slot />
    <input type="file" :accept="accept" @change="updateFileHandler" />
  </div>
</template>

<script>
export default {
  name: 'drag-drop-area',
  props: {
    accept: {
      type: String,
      required: false,
      default: '.jpg,.jpeg,.png',
    },
  },
  data() {
    return {
      statusClass: 'default',
      file: null,
    };
  },
  methods: {
    enterHandler() {
      this.statusClass = 'entered';
    },
    leaveHandler() {
      this.statusClass = 'default';
    },
    overHandler() {
      // console.log('hovering the area');
    },
    dropHandler(e) {
      this.statusClass = 'input';

      this.file = e.dataTransfer.files[0];
      this.updateFileHandler();
    },
    updateFileHandler() {
      this.$emit('input', this.file);
      this.$emit('update');
    },
  },
  mounted() {
    const preventDefaults = function(e) {
      e.preventDefault();
      e.stopPropagation();
    };
    const events = ['dragenter', 'dragleave', 'dragover', 'drop'];
    const dropArea = this.$refs.dropArea;
    events.forEach(event => {
      dropArea.addEventListener(event, preventDefaults, false);
    });
    dropArea.addEventListener('dragenter', this.enterHandler, false);
    dropArea.addEventListener('dragleave', this.leaveHandler, false);
    dropArea.addEventListener('dragover', this.overhandler, false);
    dropArea.addEventListener('drop', this.dropHandler, false);
  },
};
</script>

<style lang="scss" scoped>
.drag-drop-area {
  input[type='file'] {
    display: none;
  }
}
</style>
